module.exports = "<div class=\"contributor\" [class.matsko]=\"info?.style\">\n  <img [src]=\"info?.avatar\" alt=\"{{ info.name }}\">\n  <div class=\"name\">{{ info.name }}</div>\n  <div class=\"title\">\n    <a [href]=\"info.githubURL\">\n      {{  info.title }}\n    </a>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/about-page/contributors/contributor.component.html
// module id = 218
// module chunks = 1